import { MatxLoadable } from "matx";
import { isMdScreen } from "utils";

const AdminModuleTable = MatxLoadable({
    loader: () => import("./tables/AdminModuleTable")
  });

const AdminRoleTable = MatxLoadable({
    loader: () => import("./tables/AdminRoleTable")
  });

const AdminUserTable = MatxLoadable({
    loader: () => import("./tables/AdminUserTable")
  });

const AdminUserForm = MatxLoadable({
    loader: () => import("./forms/FormAdminUsers")
  });

  const settings = {
    activeLayout: "layout1",
    layout1Settings: {
      topbar: {
        show: true
      },
      leftSidebar: {
        show: true,
        mode: isMdScreen() ? "close" : "full"
      }
    },
    likeDislikeButtons: { show: false }
  };

  const permissionsRoutes = [
    {
      path: "/permissions/module",
      component: AdminModuleTable
    },
    {
      path: "/permissions/roles/:code",
      component: AdminRoleTable
    },
    {
      path: "/permissions/users/form/:code",
      component: AdminUserForm
    },
    {
      path: "/permissions/users/:code",
      component: AdminUserTable
    },
  ];
  
  export default permissionsRoutes;